import { render, staticRenderFns } from "./TabShareQuotePdf.vue?vue&type=template&id=b826d0a4&scoped=true&"
import script from "./TabShareQuotePdf.vue?vue&type=script&lang=js&"
export * from "./TabShareQuotePdf.vue?vue&type=script&lang=js&"
import style0 from "./TabShareQuotePdf.vue?vue&type=style&index=0&id=b826d0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b826d0a4",
  null
  
)

export default component.exports